export default [
  {
    starts: new Date(Date.UTC(2020,7,20,3,0,0)),
    ends: new Date(Date.UTC(2020,7,21,3,0,0)),
    when: new Date(Date.UTC(2020,7,20,21,0,0)),
    streamId: '83sPnoZIUi4',
    title: 'Inaguración',
    text: [
      '<p>18 hs - Introducción</p>',
      '<p>18.10 hs - Presentación de proyectos</p>',
      '<p>18.55 hs - Cierre y foto</p>',

    ]
  },
  {
    starts: new Date(Date.UTC(2020,7,27,3,0,0)),
    ends: new Date(Date.UTC(2020,7,28,3,0,0)),
    when: new Date(Date.UTC(2020,7,27,21,0,0)),
    streamId: 'HSl17as2exg',
    title: 'Semana 2: Sesión con Alejandro Echeverri',
    text: [
      '<p><b>Cronograma - Montevideo/Buenos Aires/Sao Paolo (GMT -3)</b></p><br>',
      '<p>18h - Introducción</p>',
      '<p>18.05h - Saludos BID (Tamara Egger + Hallel Elnir)</p>',
      '<p>18.15h - Conferencia (Alejandro Echeverri)</p>',
      '<p>18.35h - Preguntas y comentarios</p>',
      '<p>18.45h - Intervalo </p>',
      '<p>18.55h - Revisión de Proyectos</p>',
      '<p>19.55h - Check-out y foto de cierre</p>',

    ],
  },
  {
    starts: new Date(Date.UTC(2020,8,3,3,0,0)),
    ends: new Date(Date.UTC(2020,8,4,3,0,0)),
    when: new Date(Date.UTC(2020,8,3,21,0,0)),
    streamId: 'AzISejeYbN8',
    title: 'Semana 3: Sesión con Andrés G Blanco',
    text: [
      '<p><b>Cronograma - Montevideo/Buenos Aires/Sao Paolo (GMT -3)</b></p><br>',
      '<p>18h - Introducción</p>',
      '<p>18.05h - Conferencia</p>',
      '<p>18.45h - Sesión de preguntas </p>',
      '<p>18.55h - Check-out y foto de cierre</p>',
    ],
  },
  {
    starts: new Date(Date.UTC(2020,8,10,3,0,0)),
    ends: new Date(Date.UTC(2020,8,11,3,0,0)),
    when: new Date(Date.UTC(2020,8,10,21,0,0)),
    streamId: 'bmO5jzCaOqk',
    title: 'Semana 4: Sesión con Agustín Frizzera',
    text: [
      '<p><b>Cronograma - Montevideo/Buenos Aires/Sao Paolo (GMT -3)</b></p><br>',
      '<p>18h - Introducción</p>',
      '<p>18.05h - Resumen Maratón</p>',
      '<p>18.30h - Conferencia</p>',
      '<p>19.00h - Dialogo y preguntas</p>',
      '<p>19.25h - Check-out y foto de cierre</p>',
    ],
  },
  {
    starts: new Date(Date.UTC(2020,8,17,3,0,0)),
    ends: new Date(Date.UTC(2020,8,18,3,0,0)),
    when: new Date(Date.UTC(2020,8,17,21,0,0)),
    streamId: 'pC4OSGVWx9k',
    title: 'Semana 5: Sesión con Renata Laurentino',
    text: [
      '<p>18h - Introducción</p>',
      '<p>18.15h - Conferencia</p>',
      '<p>18.45h - Dialogo y preguntas</p>',
      '<p>19.15h - Check-out y foto de cierre</p>',
    ],
  },
  {
    starts: new Date(Date.UTC(2020,8,24,3,0,0)),
    ends: new Date(Date.UTC(2020,8,25,3,0,0)),
    when: new Date(Date.UTC(2020,8,24,21,0,0)),
    streamId: '03vdiRqHtNo',
    title: 'Semana 6: Sesión con Marialuisa Borja | Colectivo Al Borde',
    text: [
      '<p>18h - Introducción</p>',
      '<p>18.05h - Conferencia</p>',
      '<p>18.45h - Dialogo y preguntas</p>',
      '<p>19.15h - Check-out y foto de cierre</p>',
    ],
  },
  {
    starts: new Date(Date.UTC(2020,9,1,3,0,0)),
    ends: new Date(Date.UTC(2020,9,2,3,0,0)),
    when: new Date(Date.UTC(2020,9,1,21,0,0)),
    streamId: 'aEWWmFlcyt8',
    title: 'Semana 7: Sesión con Sesión con Paola Jirón Martínez',
    text: [
      '<p>18h - Introducción</p>',
      '<p>18.05h - Conferencia</p>',
      '<p>18.45h - Dialogo y preguntas</p>',
      '<p>19.15h - Check-out y foto de cierre</p>',
    ],
  },
  {
    starts: new Date(Date.UTC(2020,9,8,3,0,0)),
    ends: new Date(Date.UTC(2020,9,9,3,0,0)),
    when: new Date(Date.UTC(2020,9,8,21,0,0)),
    streamId: 'v5oca7-0kTY',
    title: 'Semana 8: Sesión especial',
    text: [
      '<p>18h - Introducción</p>',
      '<p>18.05h - Saludo equipo Ciudades Comunes</p>',
      '<p>18.15h - Sesión de preguntas y conversación</p>',
      '<p>19.15h - Check-out y foto de cierre</p>',
    ],
  },
  {
    starts: new Date(Date.UTC(2020,9,15,3,0,0)),
    ends: new Date(Date.UTC(2020,9,16,3,0,0)),
    when: new Date(Date.UTC(2020,9,15,21,0,0)),
    streamId: 'hsjHSQi4RhI',
    title: 'Semana 9: Sesión con proyectos con Menciones',
    text: [
      '<p clas="is-700">18h - Introducción</p>',
      '<p clas="is-700">18.10h - Video 4 Menciones</p>',
      '<p clas="is-700">18.30h - Conversación y comentarios sobre los proyectos</p>',
      '<p clas="is-700">19.15h - Check-out y foto de cierre</p>',
    ],
  },
  {
    starts: new Date(Date.UTC(2020,9,22,3,0,0)),
    ends: new Date(Date.UTC(2020,9,23,3,0,0)),
    when: new Date(Date.UTC(2020,9,22,21,0,0)),
    streamId: 'j-3219WZmLA',
    title: 'Semana 10 - Sesión con proyectos con Menciones',
    text: [
      '<p clas="is-700">18h - Introducción</p>',
      '<p clas="is-700">18.10h - Video 4 Menciones</p>',
      '<p clas="is-700">18.30h - Conversación y comentarios sobre los proyectos</p>',
      '<p clas="is-700">19.15h - Check-out y foto de cierre</p>',
    ],
  },
  {
    starts: new Date(Date.UTC(2020,10,19,3,0,0)),
    ends: new Date(Date.UTC(2020,10,20,3,0,0)),
    when: new Date(Date.UTC(2020,10,19,21,0,0)),
    streamId: 'iOT1hoeeyEw',
    title: 'Semana 11 - Presentacion pública y lanzamiento',
    text: [
      '<p clas="is-700">18h - Introducción y saludos iniciales</p>',
      '<p clas="is-700">18.05h - Presentación de los proyectos</p>',
      '<p clas="is-700">18.30h - Conversación con los equipos </p>',
      '<p clas="is-700">18.50h - Presentación de los manuales</p>',
      '<p clas="is-700">19h - ¡Sorpresa!</p>',
      '<p clas="is-700">19.10h - Saludos finales</p>',
      '<p clas="is-700">19.20h - Check-out y foto de cierre</p>',
    ],
  },
]